import { Link, useLocation } from "react-router-dom";
import { LogOut, Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Shell = ({ children }) => {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  return (
    <div className="relative z-10 min-h-screen">
      <header className="sticky top-0 z-40 bg-[#0A0910]/80 backdrop-blur-xl border-b border-[#262336]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-baseline" data-testid="brand-link">
            <span className="font-display text-2xl font-black lowercase tracking-tight text-white">walker</span>
          </Link>
          <div className="flex items-center gap-6">
            {pathname !== "/new" && (
              <Link
                to="/new"
                data-testid="new-valuation-link"
                className="grad-btn inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-white text-sm font-bold"
              >
                <Plus size={16} /> New valuation
              </Link>
            )}
            <div className="hidden sm:flex flex-col items-end">
              <span className="text-sm font-semibold text-white" data-testid="user-name">{user?.name}</span>
              <span className="font-mono-fin text-[10px] font-semibold uppercase tracking-[0.2em] grad-text">
                {user?.tier} tier
              </span>
            </div>
            <button
              onClick={logout}
              data-testid="logout-button"
              className="p-2.5 rounded-full border border-[#262336] bg-[#141220] text-[#9A93AD] hover:bg-[#E1306C] hover:text-white transition-colors duration-200"
              aria-label="Log out"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-12">{children}</main>
    </div>
  );
};
